module.exports = __webpack_public_path__ + "img/tutorial-clip.f4e8788f.webp";